import { render, staticRenderFns } from "./ReservaCartaoMargens.vue?vue&type=template&id=e1fe467c&scoped=true&"
import script from "./ReservaCartaoMargens.vue?vue&type=script&lang=js&"
export * from "./ReservaCartaoMargens.vue?vue&type=script&lang=js&"
import style0 from "./ReservaCartaoMargens.vue?vue&type=style&index=0&id=e1fe467c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fe467c",
  null
  
)

export default component.exports